import type { Role } from '@/entities/user';

/** Roles allowed to view COD position and run day-close. */
export const cashCodAccessRoles = [
  'admin',
  'warehouse_manager',
  'accountant',
  'finance_admin',
] as const satisfies readonly Role[];

/** Roles allowed to receive cash from riders and transfer to bank. */
export const cashCodWriteRoles = [
  'admin',
  'warehouse_manager',
  'finance_admin',
] as const satisfies readonly Role[];
